import { hasTrackingConsent } from './cookieConsent';

export const removeDataPixels = () => {
    const elementsWithDataTags = document.querySelectorAll('[data-pixel]');
    elementsWithDataTags.forEach(element => {
        element.parentNode.removeChild(element);
    });
};

export const appendPixelsToElement = (htmlString, tagElement, position, dataAttributeValue) => {
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = htmlString;

    const children = Array.from(tempContainer.childNodes);

    children.forEach(child => {
        if (child.nodeType !== Node.ELEMENT_NODE) return;

        // Handle <script> tags
        if (child.tagName === 'SCRIPT') {
            const script = document.createElement('script');
            if (child.src) script.src = child.src;
            script.text = child.textContent || child.innerHTML;
            script.async = child.async;

            if (dataAttributeValue) {
                script.setAttribute('data-pixel', dataAttributeValue);
            }

            if (position === 'top') {
                tagElement.insertBefore(script, tagElement.firstChild);
            } else {
                tagElement.appendChild(script);
            }
        }

        // Handle <noscript> tags
        else if (child.tagName === 'NOSCRIPT') {
            const noscript = document.createElement('noscript');
            noscript.innerHTML = child.innerHTML;

            if (dataAttributeValue) {
                noscript.setAttribute('data-pixel', dataAttributeValue);
            }

            if (position === 'top') {
                tagElement.insertBefore(noscript, tagElement.firstChild);
            } else {
                tagElement.appendChild(noscript);
            }
        }

        // Handle all other tags
        else {
            const clonedChild = child.cloneNode(true);

            if (dataAttributeValue) {
                clonedChild.setAttribute('data-pixel', dataAttributeValue);
            }

            if (position === 'top') {
                tagElement.insertBefore(clonedChild, tagElement.firstChild);
            } else {
                tagElement.appendChild(clonedChild);
            }
        }
    });
};

export const pagePixels = (json) => {
    // Always clear previously injected pixels first, so revoking consent (which
    // re-runs this with the gate closed) removes them. Then bail before
    // injecting unless the user has consented to tracking.
    removeDataPixels();
    if (!hasTrackingConsent()) return;

    const headPixelString = json.headPixel;
    const bodyTopPixelString = json.bodyTopPixel;
    const bodyBottomPixelString = json.bodyBottomPixel;

    if (headPixelString) {
        appendPixelsToElement(headPixelString, document.head, null, 'page-pixel');
    }
    if (bodyTopPixelString) {
        appendPixelsToElement(bodyTopPixelString, document.body, 'top', 'page-pixel');
    }
    if (bodyBottomPixelString) {
        appendPixelsToElement(bodyBottomPixelString, document.body, null, 'page-pixel');
    }
};


